import { type Theme } from "@schaeffler-commerce/design-system";
import { globalResetStyles } from "~/common/styles/GlobalResetStyles";
import { printStyles } from "~/common/styles/PrintGlobalStyles";
import { externalContentStyles } from "~/common/styles/ExternalContentGlobalStyles";
import { cmsContentStyles } from "~/common/styles/CmsContentGlobalStyles";
import { vendorAndIframeStyles, qualtricsStyles } from "~/common/styles/VendorAndIframeGlobalStyles";
import { pageNavigationStyles } from "~/common/styles/PageNavigationGlobalStyles";
import { st4ContentStyles } from "~/common/styles/St4ContentGlobalStyles";
import { rootVariablesStyles } from "~/common/styles/RootVariablesGlobalStyles";
import { utilityStyles } from "~/common/styles/UtilityClassGlobalStyles";
import { fakePartialBackdropStyles } from "~/common/components/Menu/Menu";

// Single source of truth for the app-wide global styles, rendered by the
// component registry (classic + headless hosts) and the Storybook
// withMuiTheme decorator. Keep the composition identical in both places by
// always importing from here.
export const appGlobalStyles = (theme: Theme) => ({
  // Resets/element base first: main.css carried them before every emotion
  // rule, so they must stay first among the emotion globals to keep losing
  // equal-specificity ties exactly as before.
  ...globalResetStyles(theme),
  ...printStyles(theme),
  ...externalContentStyles(theme),
  ...cmsContentStyles(theme),
  ...vendorAndIframeStyles(theme),
  ...qualtricsStyles(),
  ...pageNavigationStyles(),
  ...st4ContentStyles(theme),
  ...rootVariablesStyles(),
  // Menu's injected backdrop class (className-based, must stay global)
  ...fakePartialBackdropStyles(),
  // Utility classes last: mirrors style.less, where the utility imports sat
  // at the end of the sheet and won ties against the other global rules.
  ...utilityStyles(),
});
